import React, { useEffect, useState } from "react";
import NotAuthorized from "../../components/NotAuthorized";
import { Forms } from "./Forms";
import "./index.scss";

const NewForms = () => {
  const [isFormActive, setIsFormActive] = useState(false);

  let orgInfo = localStorage?.getItem("organization")
    ? JSON.parse(localStorage?.getItem("organization"))
    : [];

  let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  useEffect(() => {
    const status =
      orgInfo?.authorizedModules?.find(
        (item) => item?.moduleName === "forms"
      )?.active === true &&
      authorizedModulesInfo?.find((item) => item?.moduleName === "forms")
        ?.active === true
        ? true
        : false;

      setIsFormActive(status);
  }, []);

  return !isFormActive ? <NotAuthorized title={"Forms"} /> : <Forms />;
};

export default NewForms;
